export enum ColumnType {
  created = "created",
  wasteSum = "wasteSum",
}

export const columnLabels = Object.values(ColumnType);
